import { render, staticRenderFns } from "./defaultLayout.vue?vue&type=template&id=4330476b&"
import script from "./defaultLayout.vue?vue&type=script&lang=js&"
export * from "./defaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports